import styled from 'styled-components';
import { Text, color, Flexbox, Label, Theme } from '@morressier/ts';

export const MainTitle = styled(Text).attrs({
  textAs: 'div',
  size: 'body1_new'
})`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  margin-bottom: 1rem;
  color: var(--color-mono-60);
`;

export const UserEventContainer = styled.div.withConfig({
  componentId: 'UserEventContainer'
} as any)`
  margin: 5px 0px;
`;

export const UserEventDateContainer = styled.div.withConfig({
  componentId: 'EventBody'
} as any)`
  display: flex;
  flex-wrap: wrap;
`;

export const UserEventBody = styled(Flexbox)`
  display: inline-flex;
  flex: none;
  width: auto;
  margin-top: 0.5rem;
`;

type AnchorProps = {
  state: 'view' | 'manage';
};

export const UserEventAnchor = styled.a.attrs((props: AnchorProps) => ({
  size: 'body1_new',
  state: props.state
}))`
  color: var(--color-blue-40);
  margin-left: ${props => (props.state === 'manage' ? '1rem' : '0px')};
  cursor: pointer;
  text-decoration: none;
  font-weight: var(--fontWeights-semi);
  line-height: var(--lineHeights-normal);
`;

export const Title = styled(Text).attrs({
  textAs: 'div',
  size: 'body1_new'
})`
  font-weight: 700;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const EventStatus = styled(Text).attrs((props: { status: string }) => ({
  status: props.status,
  textAs: 'span',
  size: 'body1_new',
  fontWeight: 'semiBold'
}))`
  color: ${({ status }) =>
    status === 'live' ? color('red') : 'var(--color-green-60)'};
  text-transform: capitalize;
  display: inline-block;
  margin-right: ${({ status }) => (status === 'live' ? '0px' : '8px')};
`;

export const EventDuration = styled(Text).attrs({
  textAs: 'span',
  size: 'body1_new'
})`
  display: inline-block;
  color: var(--color-mono-60);
  margin-right: 8px;
`;

export const StyledLiveStatus = styled.div`
  background-color: var(--color-red-95);
  border-radius: 4px;
  padding: 0px 4px;
  display: flex;
  align-items: center;
  height: 0%;
`;

export const EmptyUserEventContainer = styled.div`
  margin-top: 25px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
`;

export const EmptyUserEventTitleContainer = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  margin: 0px 12px;
`;

export const EmptyUserEventTitle = styled(Text).attrs({
  textAs: 'div',
  size: 'caption_new'
})`
  width: fit-content;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: ${color('grey')};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const Divider = styled.div`
  border: 1px solid #d9dbdf;
  margin: 32px 0px;
`;

export const EventContainer = styled.div`
  margin-bottom: 1rem;
`;

export const StartEventTitle = styled(Text).attrs({
  textAs: 'div',
  size: 'body1_new'
})`
  font-weight: 700;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: var(--color-mono-50);
`;

export const NewEventBadge = styled.div`
  background-color: var(--chakra-colors-yellow-95);
  border-radius: 4px;
  padding: 0px 4px;
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  gap: 4px;
  margin-bottom: 4px;
  align-items: center;
`;

export const NewEventText = styled(Text).attrs({
  textAs: 'div',
  size: 'body1_new'
})`
  font-weight: 600;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
